module.exports = __webpack_public_path__ + "static/media/neutronium.ce81ac25.png";